import { Route, Routes } from "react-router-dom"

import { AppShell } from "@/components/layout/app-shell"
import { AccountRoute } from "@/routes/account"
import { ApplicationsRoute } from "@/routes/applications"
import { ChatRoute } from "@/routes/chat"
import { CodeReviewRoute } from "@/routes/code-review"
import { DocumentsRoute } from "@/routes/documents"
import { HomeRoute } from "@/routes/home"
import { InterviewRoute } from "@/routes/interview"
import { JobsRoute } from "@/routes/jobs"
import { MemoryRoute } from "@/routes/memory"
import { NotFoundRoute } from "@/routes/not-found"
import { OperatorRoute } from "@/routes/operator"
import { ResumesRoute } from "@/routes/resumes"
import { SettingsRoute } from "@/routes/settings"

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<HomeRoute />} />
        <Route path="chat" element={<ChatRoute />} />
        <Route path="jobs" element={<JobsRoute />} />
        <Route path="applications" element={<ApplicationsRoute />} />
        <Route path="documents" element={<DocumentsRoute />} />
        <Route path="interview" element={<InterviewRoute />} />
        <Route path="code-review" element={<CodeReviewRoute />} />
        <Route path="memory" element={<MemoryRoute />} />
        <Route path="cvs" element={<ResumesRoute />} />
        <Route path="account" element={<AccountRoute />} />
        <Route path="settings" element={<SettingsRoute />} />
        <Route path="operator" element={<OperatorRoute />} />
        <Route path="*" element={<NotFoundRoute />} />
      </Route>
    </Routes>
  )
}
